import { database } from '../firebase';
import { snapshotToArray } from '../helpers';
export const FETCH_USERS = 'FETCH_USERS';
export const UPDATE_USERS = 'UPDATE_USERS';
export const CURRENT_USER = 'CURRENT_USER';

export const fetchUsers = () => async dispatch => {

	database.ref("/users").once("value", snapshot => {
		dispatch({
			type: FETCH_USERS,
			payload: snapshotToArray(snapshot)
		});
	});
};

export const addUser = (user) => async dispatch => {

	database.ref("/users").push(user).then((value) => {
		user.key = value.key;

		dispatch({
			type: UPDATE_USERS,
			payload: user
		});

		dispatch({
			type: CURRENT_USER,
			payload: user
		});

	});
};

export const setUser = (user) => async dispatch => {

	dispatch({
		type: CURRENT_USER,
		payload: user
	});


}; 